import CONFIG from 'Config';

export default {
  loading: false,
  pageData: {
    seo_title: CONFIG.seo.defaultTitle,
    seo_description: CONFIG.seo.defaultDesc,
  },
  children: [],
};
